/* 🤖 this file was generated by script */
export const wiconFeather = {
  name: 'feather',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8L2 22m16-7H9m-2.4 4h6.74c.24 0 .36 0 .48-.03a1 1 0 00.29-.12c.1-.06.19-.15.36-.32l5.03-5.03.45-.46a6 6 0 00-.45-8.54l-.46-.45a6 6 0 00-8.08 0l-.46.45-5.03 5.03c-.17.17-.26.26-.32.36a1 1 0 00-.12.3c-.03.1-.03.23-.03.47v6.74c0 .56 0 .84.1 1.05a1 1 0 00.45.44c.21.11.49.11 1.05.11z"/></svg>`,
};
